require("../libs/backbone/backbone.ajaxq.adapter.ts");

var TheRouter = require("routers/main.router.ts");
var loggedIn = false;
var data = null;

var router = new TheRouter();
Backbone.history.start();

